import { z } from 'zod';

export const ProfileTypeSchema = z.enum(['hcp', 'account']);
export type ProfileType = z.infer<typeof ProfileTypeSchema>;

// ─── Base Models ─────────────────────────────────────────────────────────────

export const ProfileConfigVersionSchema = z.object({
  id: z.number().int(),
  configId: z.number().int(),
  versionNumber: z.number().int().min(1),
  config: z.record(z.string(), z.unknown()),
  createdBy: z.number().nullable(),
  createdOn: z.coerce.date(),
  description: z.string().nullable(),
});
export type ProfileConfigVersion = z.infer<typeof ProfileConfigVersionSchema>;

export const ProfileConfigSchema = z.object({
  id: z.number().int(),
  brandIdentifier: z.string(),
  applicationIdentifier: z.string(),
  profileType: ProfileTypeSchema,
  currentVersionId: z.number().nullable(),
  createdBy: z.number().nullable(),
  createdOn: z.coerce.date(),
  updatedBy: z.number(),
  updatedOn: z.coerce.date(),
});
export type ProfileConfigRecord = z.infer<typeof ProfileConfigSchema>;

export const ProfileConfigDetailSchema = ProfileConfigSchema.extend({
  currentVersion: ProfileConfigVersionSchema.nullable(),
});
export type ProfileConfigDetail = z.infer<typeof ProfileConfigDetailSchema>;

// ─── List Response ───────────────────────────────────────────────────────────

export const GetProfileConfigVersionsResponseSchema = z.object({
  versions: z.array(ProfileConfigVersionSchema),
});
export type GetProfileConfigVersionsResponse = z.infer<typeof GetProfileConfigVersionsResponseSchema>;

// ─── Request Schemas ─────────────────────────────────────────────────────────

export const CreateProfileConfigRequestSchema = z.object({
  brandIdentifier: z.string(),
  applicationIdentifier: z.string(),
  profileType: ProfileTypeSchema,
});
export type CreateProfileConfigRequest = z.infer<typeof CreateProfileConfigRequestSchema>;

export const SaveProfileConfigVersionRequestSchema = z.object({
  config: z.record(z.string(), z.unknown()),
  description: z.string().optional(),
});
export type SaveProfileConfigVersionRequest = z.infer<typeof SaveProfileConfigVersionRequestSchema>;
